import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { BiArrowBack } from "react-icons/bi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loading from "../../../components/loading/Loading";
import { MdDone, MdWarning } from "react-icons/md";

import { quatationOperasionalSelector } from "./quatationOperasionalSlice";
import {
  getMinKlien,
  klienSelector,
} from "../../../features/master/klien/klienSlice";
import "./quatation.css";
import { Colors } from "../../../assets/Colors";
import { Card, CardBody } from "@material-tailwind/react";
import { useMutation } from "@tanstack/react-query";
import { fetchGet, fetchPost } from "../../../fetchers";
import { toast } from "react-toastify";

const QuotationInvoicePage = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const quatation = useSelector(quatationOperasionalSelector);
  const klien = useSelector(klienSelector);
  const param = useLocation();

  // State untuk data
  const [data, setData] = useState({});
  const [dataDetail, setDataDetail] = useState([]);
  const [namaKlien, setNamaKlien] = useState("");

  // State untuk invoice dengan data dari payload
  const [invoiceData, setInvoiceData] = useState({
    invoiceNo: "",
    dueDate: new Date(),
    invoiceDate: new Date(),
    contract: "",
    description: "",
    dpNumber: "",
    unit: "LS",
    revisi: "",
    // Field tambahan dari payload
    invoiceId: null,
    quotationNo: "",
    klienId: "",
    klienName: "",
    workDesc: "",
    contractNo: "",
    bankAccount: "",
    subtotal: 0,
    tax: 0,
    totalAmount: 0,
    status: "",
    printCount: 0,
    createdAt: null,
    updatedAt: null,
  });

  // State untuk Nomor Rekening
  const [selectedRekening, setSelectedRekening] = useState({
    value: "",
    label: "",
  });

  // State untuk loading dan error
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

  // State untuk quotation manual
  const [quotationManual, setQuotationManual] = useState("");

  // Data rekening bank
  const [rekeningOptions, setRekeningOptions] = useState([]);

  // Options untuk field Unit
  const unitOptions = [
    { value: "-", label: "-" },
    { value: "LS", label: "LS" },
    { value: "AU", label: "AU" },
  ];

  // Mutations
  const mutationUpdate = useMutation((formData) =>
    fetchPost("getQJR", formData),
  );
  const mutationData = useMutation((formData) =>
    fetchPost("getQuatation", formData),
  );
  const detailAccount = useMutation(() =>
    fetchGet("GetMinMasterDetailAccountV2"),
  );
  const saveInvoiceMutation = useMutation((formData) =>
    fetchPost("saveInvoice", formData),
  );
  const printInvoiceMutation = useMutation((formData) =>
    fetchPost("getInvoiceNew", formData),
  );
  
  // NEW: Mutation untuk update status invoice
  const updateStatusMutation = useMutation((formData) =>
    fetchPost("updateInvoiceStatus", formData),
  );

  useEffect(() => {
    dispatch(getMinKlien({ search: "" }));

    let formData = new FormData();
    formData.append("start", "");
    formData.append("count", "");
    formData.append("search", "");
    formData.append("QuatationNo", param.state?.QuatationNo || "");

    mutationData.mutate(formData);
    mutationUpdate.mutate(formData);
    detailAccount.mutate();
  }, []);

  useEffect(() => {
    if (detailAccount.data && detailAccount.data.data) {
      const cleanLabel = (label) => {
        if (!label) return "";
        const match = label.match(/\((.*?)\)/);
        if (match && match[1]) {
          return match[1].trim();
        }
        const cleaned = label.replace(/^[\d\s\-\.]+\s*/, "").trim();
        return cleaned;
      };

      const bankData = (detailAccount.data.data || []).filter((item) => {
        if (!item.label) return false;
        const labelLower = item.label.toLowerCase();
        return labelLower.includes("bank");
      });

      if (bankData.length > 0) {
        const apiBankOptions = bankData.map((item) => ({
          value: item.value,
          label: cleanLabel(item.label),
        }));

        setRekeningOptions([...apiBankOptions]);
      }
    }
  }, [detailAccount.data]);

  // Set data dari payload ke state
  useEffect(() => {
    if (mutationData.data && mutationData.data.data) {
      const quotationData = mutationData.data.data;
      setData(quotationData);

      // Set data quotation
      if (quotationData.KlienID && klien.minData) {
        const klienData = klien.minData.find(
          (item) => item.value === quotationData.KlienID,
        );
        if (klienData) {
          setNamaKlien(klienData.label);
        }
      }

      // Set data invoice dari payload
      if (quotationData.invoice_id) {
        setInvoiceData({
          invoiceNo: quotationData.invoice_no || "",
          dueDate: quotationData.due_date ? new Date(quotationData.due_date) : new Date(),
          invoiceDate: quotationData.invoice_date ? new Date(quotationData.invoice_date) : new Date(),
          contract: quotationData.contract_no_invoice || quotationData.NoKontrak || "",
          description: quotationData.description_invoice || "",
          dpNumber: quotationData.dp_number || "",
          unit: quotationData.unit || "LS",
          revisi: quotationData.revisi || "",
          // Field tambahan
          invoiceId: quotationData.invoice_id,
          quotationNo: quotationData.quotation_no || "",
          klienId: quotationData.klien_id_invoice || "",
          klienName: quotationData.klien_name_invoice || "",
          workDesc: quotationData.work_desc_invoice || "",
          contractNo: quotationData.contract_no_invoice || "",
          bankAccount: quotationData.bank_account || "",
          subtotal: quotationData.subtotal || 0,
          tax: quotationData.tax || 0,
          totalAmount: quotationData.total_amount || 0,
          status: quotationData.status || "",
          printCount: quotationData.print_count || 0,
          createdAt: quotationData.created_at ? new Date(quotationData.created_at) : null,
          updatedAt: quotationData.updated_at ? new Date(quotationData.updated_at) : null,
        });

        // Set selected rekening jika ada
        if (quotationData.bank_account) {
          setSelectedRekening({
            value: quotationData.bank_account,
            label: quotationData.bank_account,
          });
        }

        // Set quotation manual
        if (quotationData.quotation_manual) {
          setQuotationManual(quotationData.quotation_manual);
        }
      }
    }
  }, [mutationData.data, klien.minData]);

  useEffect(() => {
    if (mutationUpdate.data) {
      setDataDetail(mutationUpdate.data.data || []);
    }
  }, [mutationUpdate.data]);

  // Fungsi untuk mengecek apakah form harus disabled
  const isFormDisabled = () => {
    return invoiceData.status?.toLowerCase() === "done";
  };

  // Fungsi untuk mengecek apakah tombol Done harus ditampilkan
  const showDoneButton = () => {
    return invoiceData.status?.toLowerCase() === "sent";
  };

  // Handler untuk perubahan select
  const handleRekeningChange = (selectedOption) => {
    setSelectedRekening(selectedOption);
  };

  // Handler untuk perubahan unit
  const handleUnitChange = (selectedOption) => {
    setInvoiceData({ ...invoiceData, unit: selectedOption.value });
  };

  // Validasi form sebelum save
  const validateForm = () => {
    if (isFormDisabled()) {
      return "Invoice dengan status DONE tidak dapat diubah";
    }

    if (!invoiceData.invoiceNo.trim()) {
      return "Nomor Invoice harus diisi";
    }

    if (!invoiceData.dueDate) {
      return "Due Date harus diisi";
    }

    if (!invoiceData.invoiceDate) {
      return "Tanggal Invoice harus diisi";
    }

    // Validasi due date tidak boleh sebelum invoice date
    if (invoiceData.dueDate < invoiceData.invoiceDate) {
      return "Due Date tidak boleh sebelum Tanggal Invoice";
    }

    // Cek apakah ada JR yang dipilih
    const selectedJRs = (dataDetail || []).filter((item) => item?.Checked);
    if (selectedJRs.length === 0) {
      return "Pilih minimal satu Job Request";
    }

    if (!selectedRekening || !selectedRekening.value) {
      return "Pilih Nomor Rekening";
    }

    return null;
  };

  // Handle checkbox JR
  const handleJRCheckbox = (index) => {
    if (isFormDisabled()) return; // Tidak bisa mengubah jika status DONE
    
    const updatedData = [...(dataDetail || [])];
    if (updatedData[index]) {
      updatedData[index] = {
        ...updatedData[index],
        Checked: !updatedData[index].Checked,
      };
      setDataDetail(updatedData);
    }
  };

  // NEW: Handler untuk tombol Done
  const handleDoneStatus = async () => {
    if (!invoiceData.invoiceId) {
      toast.error("Invoice ID tidak ditemukan");
      return;
    }

    // Konfirmasi sebelum mengubah status
    if (!window.confirm("Apakah Anda yakin ingin mengubah status invoice menjadi DONE? Tindakan ini tidak dapat dibatalkan.")) {
      return;
    }

    setIsUpdatingStatus(true);
    setSaveError(null);

    try {
      const payload = {
        invoice_id: invoiceData.invoiceId,
        status: "done"
      };

      const response = await updateStatusMutation.mutateAsync(payload);

      if (response && response.status === "Success") {
        toast.success("Status invoice berhasil diubah menjadi DONE");
        
        // Update status di state
        setInvoiceData({
          ...invoiceData,
          status: "done"
        });

        // Refresh data untuk mendapatkan data terbaru
        let formData = new FormData();
        formData.append("start", "");
        formData.append("count", "");
        formData.append("search", "");
        formData.append("QuatationNo", param.state?.QuatationNo || "");
        mutationData.mutate(formData);
      } else {
        throw new Error(response?.message || "Gagal mengubah status invoice");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(`Gagal mengubah status: ${error.message}`);
      setSaveError(error.message);
    } finally {
      setIsUpdatingStatus(false);
    }
  };

  async function cetakInvoice() {
    if (isFormDisabled()) {
      toast.error("Invoice dengan status DONE tidak dapat dicetak");
      return;
    }

    setSaveError(null);

    const validationError = validateForm();
    if (validationError) {
      toast.error(validationError);
      return;
    }

    try {
      setIsSaving(true);

      // 1. Siapkan data JR yang dipilih
      let printDetail = [];
      (dataDetail || []).forEach((detail) => {
        if (detail?.Checked) {
          printDetail.push(detail.JRID);
        }
      });

      // Format tanggal dengan benar
      const formatDate = (date) => {
        if (!date) return new Date().toISOString();
        const dateObj = date instanceof Date ? date : new Date(date);
        return dateObj.toISOString();
      };

      // 2. Siapkan payload sesuai dengan inputan
      const saveData = {
        invoice_no: invoiceData.invoiceNo,
        quotation_no: param.state?.QuatationNo || "",
        quotation_manual: quotationManual,
        klien_id: data.KlienID || "",
        klien_name: namaKlien || "",
        contract: invoiceData.contract || data.NoKontrak || "",
        due_date: formatDate(invoiceData.dueDate),
        invoice_date: formatDate(invoiceData.invoiceDate),
        description: invoiceData.description || `Invoice untuk ${param.state?.QuatationNo || ""}`,
        bank_account: selectedRekening ? selectedRekening.label : "",
        bank_account_id: selectedRekening ? selectedRekening.value : "",
        detail: printDetail,
        created_by: 1,
        dp_number: invoiceData.dpNumber || "",
        unit: invoiceData.unit || "LS",
        revisi: invoiceData.revisi || "",
        work_desc: data.WorkDesc || "",
      };

      console.log("Payload yang akan dikirim:", JSON.stringify(saveData, null, 2));

      // 3. Simpan invoice ke database
      const saveResponse = await saveInvoiceMutation.mutateAsync(saveData);

      if (
        !saveResponse ||
        saveResponse.status === "Error" ||
        saveResponse.status !== "Success"
      ) {
        const errorMsg =
          saveResponse?.message ||
          saveResponse?.error ||
          "Gagal menyimpan invoice";
        throw new Error(errorMsg);
      }

      const invoiceID =
        saveResponse.data?.invoice_id ||
        saveResponse.invoice_id ||
        saveResponse.data?.id ||
        saveResponse.id;

      if (!invoiceID) {
        throw new Error("Server tidak mengembalikan ID invoice");
      }

      // 4. Cetak invoice
      const printResponse = await printInvoiceMutation.mutateAsync({
        invoice_id: invoiceID,
      });

      if (!printResponse || printResponse.status !== "Success") {
        throw new Error(printResponse?.message || "Gagal mencetak invoice");
      }

      // 5. Navigasi ke halaman cetak dengan data lengkap
      navigate("/finance/report/invoice/cetak", {
        state: {
          invoice_id: invoiceID,
          invoiceData: printResponse.data || printResponse,
          Detail: printDetail,
          NomorRekening: selectedRekening ? selectedRekening.label : "",
          NomorRekeningId: selectedRekening ? selectedRekening.value : "",
          QuatationNo: param.state?.QuatationNo || "",
          QuatationManual: quotationManual,
          InvoiceNo: invoiceData.invoiceNo,
          DueDate: invoiceData.dueDate,
          InvoiceDate: invoiceData.invoiceDate,
          Contract: invoiceData.contract || data.NoKontrak,
          Description: invoiceData.description || `Invoice untuk ${param.state?.QuatationNo || ""}`,
          DPNumber: invoiceData.dpNumber || "",
          Unit: invoiceData.unit || "LS",
          Revisi: invoiceData.revisi || "",
          WorkDesc: data.WorkDesc || "",
          KlienID: data.KlienID || "",
          KlienName: namaKlien || "",
          // Data tambahan dari payload
          Subtotal: invoiceData.subtotal,
          Tax: invoiceData.tax,
          TotalAmount: invoiceData.totalAmount,
          Status: invoiceData.status,
          PrintCount: invoiceData.printCount,
        },
      });
    } catch (error) {
      console.error("Error detail:", error);
      let errorMessage = "Gagal mencetak invoice: " + error.message;
      setSaveError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsSaving(false);
    }
  }

  // Loading state
  if (mutationUpdate.isLoading || mutationData.isLoading) {
    return <Loading />;
  }

  // Check if quotation data exists
  if (!param.state?.QuatationNo) {
    return (
      <div className="md:ml-64 p-4">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          <p>Quotation number tidak ditemukan.</p>
          <button
            onClick={() => navigate("/finance/report/invoice")}
            className="mt-2 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-3 border border-gray-400 rounded text-sm"
          >
            Kembali ke Daftar Invoice
          </button>
        </div>
      </div>
    );
  }

  const formDisabled = isFormDisabled();

  return (
    <>
      <div className="md:ml-64">
        <div className="flex w-full justify-between px-4 flex-col sm:flex-row pt-4">
          <button
            onClick={() => navigate("/finance/report/invoice")}
            className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
          >
            <BiArrowBack className="text-xl text-gray-800 pr-2" />
            Back
          </button>
          
          <div className="flex items-center gap-2 m-2 sm:my-0">
            {/* Status Badge */}
            {invoiceData.status && (
              <span className={`px-3 py-2 rounded text-sm font-semibold ${
                invoiceData.status.toLowerCase() === 'done' ? 'bg-green-100 text-green-800' : 
                invoiceData.status.toLowerCase() === 'sent' ? 'bg-blue-100 text-blue-800' : 
                invoiceData.status.toLowerCase() === 'draft' ? 'bg-yellow-100 text-yellow-800' : 
                'bg-gray-100 text-gray-800'
              }`}>
                Status: {invoiceData.status.toUpperCase()}
              </span>
            )}

            {/* NEW: Tombol Done - hanya muncul jika status = sent */}
            {showDoneButton() && (
              <button
                onClick={handleDoneStatus}
                disabled={isUpdatingStatus || updateStatusMutation.isLoading}
                className="flex items-center gap-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-200 text-sm font-medium shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                title="Ubah status menjadi DONE"
              >
                {isUpdatingStatus || updateStatusMutation.isLoading ? (
                  <>
                    <svg className="animate-spin h-4 w-4 mr-2" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    Memproses...
                  </>
                ) : (
                  <>
                    <MdDone size={18} />
                    <span>Done</span>
                  </>
                )}
              </button>
            )}
          </div>
        </div>

        {/* Pesan warning jika status DONE */}
        {formDisabled && (
          <div className="px-4 py-2">
            <div className="bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-3 rounded flex items-center gap-2">
              <MdWarning size={20} className="text-yellow-600" />
              <div>
                <strong>Perhatian:</strong> Invoice dengan status DONE tidak dapat diubah atau dicetak ulang.
              </div>
            </div>
          </div>
        )}

        {/* Error Message */}
        {saveError && (
          <div className="px-4 py-2">
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
              <strong>Error:</strong> {saveError}
            </div>
          </div>
        )}

        <div className="px-4 py-4">
          {/* Informasi Invoice yang sudah ada */}
          {invoiceData.invoiceId && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">Informasi Invoice Tersimpan</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div>
                  <p className="text-xs text-blue-600">Revisi</p>
                  <p className="font-medium">{invoiceData.revisi || "-"}</p>
                </div>
                <div>
                  <p className="text-xs text-blue-600">Subtotal</p>
                  <p className="font-medium">Rp {invoiceData.subtotal?.toLocaleString() || "0"}</p>
                </div>
                <div>
                  <p className="text-xs text-blue-600">Total</p>
                  <p className="font-medium">Rp {invoiceData.totalAmount?.toLocaleString() || "0"}</p>
                </div>
                <div>
                  <p className="text-xs text-blue-600">Print Count</p>
                  <p className="font-medium">{invoiceData.printCount || "0"}x</p>
                </div>
              </div>
            </div>
          )}

          {/* DP Number & Invoice No */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                DP Number
              </label>
              <input
                value={invoiceData.dpNumber}
                onChange={(e) =>
                  setInvoiceData({ ...invoiceData, dpNumber: e.target.value })
                }
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                type="text"
                placeholder="Masukkan DP Number"
                disabled={formDisabled}
              />
            </div>
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Invoice No *
              </label>
              <input
                value={invoiceData.invoiceNo}
                onChange={(e) =>
                  setInvoiceData({
                    ...invoiceData,
                    invoiceNo: e.target.value,
                  })
                }
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                type="text"
                placeholder="Contoh: INV/2024/001"
                required
                disabled={formDisabled}
              />
              <p className="text-gray-600 text-xs italic">Wajib diisi</p>
            </div>
          </div>

          {/* Quotation Import & Manual */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Quotation Import
              </label>
              <input
                value={param.state?.QuatationNo || data.QuatationNo || ""}
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                type="text"
                disabled={true}
              />
            </div>

            <div className="w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Quotation Manual
              </label>
              <input
                value={quotationManual}
                onChange={(e) => setQuotationManual(e.target.value)}
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                type="text"
                placeholder="Masukkan quotation manual (opsional)"
                disabled={formDisabled}
              />
              <p className="text-gray-600 text-xs italic">
                Opsional, isi jika ada quotation manual
              </p>
            </div>
          </div>

          {/* Contract & Client */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Number contract
              </label>
              <input
                value={data.NoKontrak || invoiceData.contractNo || ""}
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                type="text"
                disabled={true}
              />
            </div>

            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Contract
              </label>
              <input
                value={invoiceData.contract}
                onChange={(e) =>
                  setInvoiceData({ ...invoiceData, contract: e.target.value })
                }
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                type="text"
                placeholder="Masukkan nomor kontrak"
                disabled={formDisabled}
              />
            </div>
          </div>

          {/* Client, Nomor Rekening, Work Desc */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-1/3 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Client
              </label>
              <div className="inline-block relative w-full">
                <Select
                  menuPortalTarget={document.body}
                  value={
                    klien.minData &&
                    klien.minData.filter(({ value }) => value === data.KlienID)
                  }
                  disabled={true}
                  options={klien.minData || []}
                />
              </div>
              {invoiceData.klienName && (
                <p className="text-xs text-gray-500 mt-1">{invoiceData.klienName}</p>
              )}
            </div>

            <div className="w-1/3 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Nomor Rekening *
              </label>
              <div className="inline-block relative w-full">
                <Select
                  menuPortalTarget={document.body}
                  value={selectedRekening}
                  onChange={handleRekeningChange}
                  options={rekeningOptions}
                  placeholder="Pilih Bank"
                  isClearable={false}
                  isLoading={detailAccount.isLoading}
                  isDisabled={formDisabled}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      border: "1px solid #d1d5db",
                      borderRadius: "0.375rem",
                      padding: "2px",
                      backgroundColor: "white",
                      minHeight: "45px",
                      "&:hover": {
                        borderColor: "#d1d5db",
                      },
                    }),
                    menuPortal: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
              </div>
              <p className="text-gray-600 text-xs italic">
                Pilih rekening bank untuk pembayaran
              </p>
            </div>
            <div className="w-1/3 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Work Desc
              </label>
              <input
                value={data.WorkDesc || invoiceData.workDesc || ""}
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                type="text"
                disabled={true}
              />
            </div>
          </div>

          {/* Expire Date, Due Date, dan Tanggal Invoice */}
          <div className="flex flex-wrap -mx-3 mb-4">
            <div className="w-1/3 px-3 mb-4 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Expire Date
              </label>
              <DatePicker
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                selected={
                  data.ExpireDate ? new Date(data.ExpireDate) : new Date()
                }
                disabled={true}
              />
            </div>
            <div className="w-full md:w-1/3 px-3 mb-4 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Tanggal Invoice *
              </label>
              <DatePicker
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                selected={invoiceData.invoiceDate}
                onChange={(date) =>
                  setInvoiceData({ ...invoiceData, invoiceDate: date })
                }
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                required
                disabled={formDisabled}
              />
              <p className="text-gray-600 text-xs italic">Wajib diisi</p>
            </div>
            <div className="w-full md:w-1/3 px-3 mb-4 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Due Date *
              </label>
              <DatePicker
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                selected={invoiceData.dueDate}
                onChange={(date) =>
                  setInvoiceData({ ...invoiceData, dueDate: date })
                }
                dateFormat="dd/MM/yyyy"
                minDate={invoiceData.invoiceDate}
                required
                disabled={formDisabled}
              />
              <p className="text-gray-600 text-xs italic">Wajib diisi</p>
            </div>
          </div>

          {/* Deskripsi, Unit, dan Revisi */}
          <div className="flex flex-wrap -mx-3 mb-4">
            <div className="md:w-1/3 px-3 mb-4 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Deskripsi
              </label>
              <input
                value={invoiceData.description}
                onChange={(e) =>
                  setInvoiceData({
                    ...invoiceData,
                    description: e.target.value,
                  })
                }
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                type="text"
                placeholder="Deskripsi invoice"
                disabled={formDisabled}
              />
            </div>
            <div className="w-1/3 px-3 mb-4 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Unit
              </label>
              <div className="inline-block relative w-full">
                <Select
                  menuPortalTarget={document.body}
                  value={unitOptions.find(
                    (option) => option.value === invoiceData.unit,
                  )}
                  onChange={handleUnitChange}
                  options={unitOptions}
                  isDisabled={formDisabled}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      border: "1px solid #d1d5db",
                      borderRadius: "0.375rem",
                      padding: "2px",
                      backgroundColor: "white",
                      minHeight: "45px",
                      "&:hover": {
                        borderColor: "#d1d5db",
                      },
                    }),
                    menuPortal: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
              </div>
              <p className="text-gray-600 text-xs italic">
                Pilih Unit (LS atau AU)
              </p>
            </div>
            <div className="md:w-1/3 px-3 mb-4 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Revisi
              </label>
              <input
                value={invoiceData.revisi}
                onChange={(e) =>
                  setInvoiceData({
                    ...invoiceData,
                    revisi: e.target.value,
                  })
                }
                className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                type="text"
                placeholder="Revisi invoice"
                disabled={formDisabled}
              />
            </div>
          </div>

          {/* Section Data JR */}
          <div className="flex flex-wrap -mx-3 px-3 mb-6 mt-3">
            <div
              style={{
                background: Colors.primary,
              }}
              className="w-full px-4 border border-gray-500 activity rounded py-3 text-white"
            >
              Data Job Request {formDisabled ? "(Read Only)" : "(Pilih minimal satu)"}
            </div>
          </div>
        </div>

        {/* Card untuk tabel JR dan tombol cetak */}
        <Card className="flex flex-col items-center content-center rounded-t-none">
          <CardBody className="w-full pt-0">
            {/* Tombol Cetak */}
            <div className="px-3 mb-6 w-full">
              <button
                onClick={cetakInvoice}
                disabled={
                  isSaving ||
                  saveInvoiceMutation.isLoading ||
                  printInvoiceMutation.isLoading ||
                  formDisabled
                }
                className="appearance-none block text-center w-40 text-gray-700 py-2 px-2 border border-gray-200 rounded leading-tight outline-none bg-white border-gray-500 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSaving || saveInvoiceMutation.isLoading ? (
                  <span className="flex items-center justify-center">
                    <svg
                      className="animate-spin h-5 w-5 mr-2 text-gray-600"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Menyimpan...
                  </span>
                ) : (
                  formDisabled ? "Tidak Dapat Dicetak" : "Cetak Invoice"
                )}
              </button>

              {/* Info jumlah JR yang dipilih */}
              <div className="mt-2">
                <p className="text-sm text-gray-600">
                  {(dataDetail || []).filter((item) => item?.Checked).length} JR
                  dipilih dari total {(dataDetail || []).length} JR
                </p>
                {quotationManual && (
                  <p className="text-sm text-gray-600 mt-1">
                    Quotation Manual:{" "}
                    <span className="font-semibold">{quotationManual}</span>
                  </p>
                )}
                {invoiceData.dpNumber && (
                  <p className="text-sm text-gray-600 mt-1">
                    DP Number:{" "}
                    <span className="font-semibold">
                      {invoiceData.dpNumber}
                    </span>
                  </p>
                )}
                <p className="text-sm text-gray-600 mt-1">
                  Unit:{" "}
                  <span className="font-semibold">{invoiceData.unit}</span>
                </p>
                <p className="text-sm text-gray-600 mt-1">
                  Tanggal Invoice:{" "}
                  <span className="font-semibold">
                    {invoiceData.invoiceDate?.toLocaleDateString("id-ID")}
                  </span>
                </p>
                <p className="text-sm text-gray-600 mt-1">
                  Due Date:{" "}
                  <span className="font-semibold">
                    {invoiceData.dueDate?.toLocaleDateString("id-ID")}
                  </span>
                </p>
              </div>
            </div>

            {/* Tabel JR */}
            <div className="flex flex-wrap -mx-3 mb-6">
              {dataDetail && dataDetail.length > 0 ? (
                <table className="table-row-group overflow-x-auto scroll-auto bg-transparent border-collapse w-100">
                  <thead>
                    <tr>
                      <th
                        style={{ color: Colors.primary }}
                        className="sticky font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                      >
                        Pilih
                      </th>
                      <th
                        style={{ color: Colors.primary }}
                        className="sticky font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                      >
                        Job Request No.
                      </th>
                      <th
                        style={{ color: Colors.primary }}
                        className="sticky font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                      >
                        Tanggal Kedatangan
                      </th>
                      <th
                        style={{ color: Colors.primary }}
                        className="sticky font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataDetail.map((detail, id) => {
                      // HANYA JR dengan status 200 (Selesai) yang BISA di-checklist
                      // Status lainnya (Draft -1, atau status proses 99-199) harus DISABLED
                      const isNotFinished = detail?.Status !== '200';
                      
                      // Tentukan class untuk badge status
                      const statusClass = detail?.Status === '200'
                        ? 'bg-green-100 text-green-800'
                        : detail?.Status === '-1'
                        ? 'bg-red-100 text-red-800'
                        : detail?.Status === '105' || detail?.Status === '106'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-blue-100 text-blue-800';

                      return (
                        <tr key={id} className={`hover:bg-gray-50 ${isNotFinished ? 'bg-gray-100' : ''}`}>
                          <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-center">
                            <input
                              type="checkbox"
                              id={`custom-checkbox-${id}`}
                              checked={detail?.Checked || false}
                              onChange={() => handleJRCheckbox(id)}
                              className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              disabled={formDisabled || isNotFinished}
                              title={isNotFinished ? "Hanya JR dengan status Selesai (200) yang dapat diproses invoice" : ""}
                            />
                          </td>
                          <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-center">
                            {detail?.JRID || "-"}
                          </td>
                          <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-center">
                            {detail?.IncomingDate
                              ? new Date(detail.IncomingDate).toLocaleDateString(
                                  "id-ID",
                                  {
                                    weekday: "long",
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  },
                                )
                              : "-"}
                          </td>
                          <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-center">
                            {detail?.StatusKet ? (
                              <span className={`px-2 py-1 rounded text-xs font-semibold ${statusClass}`}>
                                {detail.StatusKet}
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <div className="w-full px-3">
                  <div className="bg-gray-100 border border-gray-300 rounded p-4 text-center">
                    <p className="text-gray-600">Tidak ada data Job Request</p>
                    <p className="text-sm text-gray-500 mt-1">
                      Quotation ini belum memiliki Job Request yang terkait
                    </p>
                  </div>
                </div>
              )}
            </div>
          </CardBody>
        </Card>

        {/* Loading overlay */}
        {(saveInvoiceMutation.isLoading || printInvoiceMutation.isLoading || isUpdatingStatus || updateStatusMutation.isLoading) && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="flex items-center">
                <svg
                  className="animate-spin h-8 w-8 text-blue-600 mr-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <div>
                  <p className="text-lg font-semibold">Memproses Invoice</p>
                  <p className="text-gray-600">
                    {isUpdatingStatus || updateStatusMutation.isLoading
                      ? "Mengupdate status..."
                      : saveInvoiceMutation.isLoading
                      ? "Menyimpan data..."
                      : "Mencetak invoice..."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default QuotationInvoicePage;